export const getArrowIconPath = (languageDirection) => {

    let arrowIconNext
    let arrowIconPrevious

    if (languageDirection === 'rtl') {
        arrowIconNext = require(`../assets/svg/arrow-left.svg`).default;
        arrowIconPrevious = require(`../assets/svg/arrow-right.svg`).default;
    } else {
        arrowIconNext = require(`../assets/svg/arrow-right.svg`).default;
        arrowIconPrevious = require(`../assets/svg/arrow-left.svg`).default;
    }

    return {
        arrowIconNext,
        arrowIconPrevious,
    };
};


// WEBPACK FOOTER //
// ./src/utils/svgConfig.js